<template>
  <div class="main-content">
    <!-- Page Header Start -->
    <PageHeader>
      <PageHeaderTitleContent>
        <TitleTextContent
          :titleText="'Contact Us'"
        />
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->
    <!-- Start Contact Area -->
    <section class="section contact-area">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-7 col-12">
            <div class="contact-main form-box">
              <div class="contact-inner z-index9">
                <div class="section-title">
                  <h2 class="text-white">Let's Connect</h2>
                </div>
                <div class="contact-address mt-5">
                  <h2 class="text-white">About Us</h2>
                  <div class="address mt-2">
                    <p class="text-white">
                      Project Spectrum is a comprehensive, cost-effective
                      platform that provides companies, institutions, and
                      organizations with cybersecurity information, resources,
                      tools, and training. Our mission is to improve
                      cybersecurity readiness, resiliency, and compliance for
                      small/medium-sized businesses and the federal
                      manufacturing supply chain.
                    </p>
                  </div>
                </div>
                <div class="contact-email mt-5">
                  <h2 class="text-white">Training Inquiries</h2>
                  <div class="address text-white mt-2">
                    <p>For training inquiries, please contact</p>
                    <a
                      class="link-white"
                      href="mailto:outreach@projectspectrum.io"
                      >outreach@projectspectrum.io</a
                    >
                  </div>
                </div>
                <div class="contact-email mt-5">
                  <h2 class="text-white">Site Support</h2>
                  <div class="address text-white mt-2">
                    <p>For help with this website, please contact</p>
                    <a
                      class="link-white"
                      href="mailto:support@projectspectrum.io"
                      >support@projectspectrum.io</a
                    >
                  </div>
                </div>
                <div class="social-media-transparent mt-5">
                  <ul
                    class="social-links list-unstyled d-flex justify-content-start"
                  >
                    <li class="linkedin">
                      <a
                        href="https://www.linkedin.com/showcase/project-spectrum/"
                        title="Linkedin"
                        target="_blank"
                      >
                        <i class="mdi mdi-linkedin font-20"></i>
                      </a>
                    </li>
                    <!-- <li class="twitter">
                      <a
                        href="https://twitter.com/ProjectSpectru5"
                        title="Twitter"
                        target="_blank"
                      >
                        <i class="mdi mdi-twitter font-20"></i>
                      </a>
                    </li> -->
                    <li class="youtube">
                      <a
                        href="https://www.youtube.com/channel/UCHU-4dUkYInJhpabvW6Ps1g/videos"
                        title="Youtube"
                        target="_blank"
                      >
                        <i class="mdi mdi-youtube font-20"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-12">
            <div class="mt-5">
              <b-alert
                :variant="dismissableAlertVariant"
                class="mt-1"
                dismissible
                fade
                :show="showDismissibleAlert"
                @dismissed="showDismissibleAlert = false"
              >
                {{ dismissableAlertText }}
              </b-alert>
              <h2 class="pb-4">Send us a message</h2>
              <div class="row">
                <div class="col-12">
                  <b-form-group>
                    <b-form-input
                      type="text"
                      name="name"
                      v-model="$v.form.name.$model"
                      :state="validateState('name')"
                      aria-describedby="input-name-feedback"
                      placeholder="Name"
                    >
                    </b-form-input>
                    <b-form-invalid-feedback id="input-name-feedback"
                      >Please enter a name.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </div>
                <div class="col-12">
                  <b-form-group>
                    <b-form-input
                      type="email"
                      class="form-control"
                      name="email"
                      v-model="$v.form.email.$model"
                      :state="validateState('email')"
                      placeholder="Email"
                      aria-describedby="input-email-feedback"
                      required="required"
                    >
                    </b-form-input>
                    <b-form-invalid-feedback id="input-email-feedback"
                      >Please enter a valid email
                      address.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <b-form-group>
                    <b-form-input
                      type="text"
                      name="phone"
                      v-model="$v.form.phone.$model"
                      :state="validateState('phone')"
                      value=""
                      aria-describedby="input-phonr-feedback"
                      placeholder="Phone"
                    >
                    </b-form-input>
                    <b-form-invalid-feedback id="input-phone-feedback"
                      >Please enter a phone number.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </div>
                <div class="col-12">
                  <b-form-group>
                    <b-form-input
                      type="text"
                      name="organization"
                      v-model="$v.form.organization.$model"
                      :state="validateState('organization')"
                      value=""
                      size="40"
                      aria-describedby="input-organization-feedback"
                      placeholder="Organization"
                    >
                    </b-form-input>
                    <b-form-invalid-feedback id="input-organization-feedback"
                      >Please enter an organization.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <b-form-group>
                    <b-form-textarea
                      name="message"
                      v-model="$v.form.message.$model"
                      :state="validateState('message')"
                      rows="7"
                      placeholder="How can we help you?"
                    >
                    </b-form-textarea>
                    <b-form-invalid-feedback id="input-organization-feedback"
                      >Please enter a message.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <vue-recaptcha
                    class="pb-1"
                    :sitekey="sitekey"
                    :loadRecaptchaScript="true"
                    @verify="verifyMethod"
                    @expired="expiredMethod"
                    @render="renderMethod"
                    @error="errorMethod"
                  >
                  </vue-recaptcha>
                  <b-form-invalid-feedback :state="captchaValidated">
                    Please complete the captcha by selecting the checkbox.
                  </b-form-invalid-feedback>
                  <button
                    type="submit"
                    @click="submit"
                    class="btn theme-btn w-100 rounded mt-1"
                  >
                    Send Message
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Contact Area -->
  </div>
</template>
<script>
import VueRecaptcha from "vue-recaptcha"
import axios from "axios"
import { validationMixin } from "vuelidate"
import { required, email } from "vuelidate/lib/validators"
import PageHeader from "./library/widgets/page-header.vue";
import PageHeaderTitleContent from "./library/widgets/page-header-title-content.vue";
import TitleTextContent from "./library/widgets/title-text-content.vue";
export default {
  mixins: [validationMixin],
  name: "contact",
  data() {
    return {
      /* Form Test Parameters */
      // form: {
      //     name: "Test User",
      //     email: "testemail@eccalon.com",
      //     phone: "123-456-7890",
      //     organization: "Eccalon",
      //     message: "This is a test message.",
      // },
      /* Form Empty Parameters */
      form: {
        name: null,
        email: null,
        phone: null,
        organization: null,
        message: null,
      },
      sitekey: "6LfwD60UAAAAAFbz5jRRMiCXI5cWFI0TP0MN8gXX",
      recaptcha: null,
      recaptchaVerified: false,
      captchaValidated: null,
      showDismissibleAlert: false,
      dismissableAlertText: "Dismissable Alert",
      dismissableAlertVariant: "danger",
    }
  },
  validations: {
    form: {
      name: { required },
      email: { required, email },
      phone: { required },
      organization: { required },
      message: { required },
    },
  },
  components: { 
    VueRecaptcha, 
    PageHeader,
    PageHeaderTitleContent,
    TitleTextContent,
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      /* The footer height no longer needs to be set */
      // this.initFooterHeight();
    },
    initFooterHeight() {
      var footerHeight = $("footer").outerHeight()
      $(".main-content").css("margin-bottom", footerHeight)
    },
    validateState(name) {
      const field = this.$v.form[name]
      if (field && field.$dirty) {
        // Check if the field has been interacted with
        return !field.$error // Returns true if there's no error, false otherwise
      }
      return null // No validation state to show yet
    },
    submit() {
      // Verify the form input fields
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      // Verify the captcha state
      if (!this.recaptchaVerified) {
        this.captchaValidated = false
        return
      }
      // Submit the contact entry
      /*console.log(
        'Submit',
        this.name,
        this.email,
        this.phone,
        this.organization,
        this.message
      );*/
      /*  API call to server: GET /api/resources/blogs  */
      axios
        .post("/api/contact/save", {
          name: this.form.name,
          email: this.form.email,
          "g-recaptcha-response": this.recaptcha,
          // organization: this.form.organization,
          phone: this.form.phone,
          message: this.form.message,
        })
        .then((response) => {
          //console.log(response);
          this.resetForm()
          this.dismissableAlertText = "Message Sent!"
          this.showDismissibleAlert = true
          this.dismissableAlertVariant = "success"
        })
        .catch((error) => {
          //console.error(error);
          this.dismissableAlertText = error
          this.showDismissibleAlert = true
          this.dismissableAlertVariant = "danger"
        })
    },
    resetForm() {
      this.form = {
        name: null,
        email: null,
        phone: null,
        organization: null,
        message: null,
      }
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    verifyMethod(responce) {
      //console.log('ReCaptcha Verified', responce);
      this.recaptchaVerified = true
      this.recaptcha = responce
      this.captchaValidated = true
    },
    expiredMethod() {
      //console.warn('ReCaptcha Expired');
      this.recaptchaVerified = false
      this.recaptcha = false
      this.captchaValidated = false
    },
    renderMethod() {
      console.log("ReCaptcha Rendered")
    },
    errorMethod() {
      console.error("ReCaptcha Error")
      this.recaptchaVerified = false
      this.recaptcha = false
    },
  },
}
</script>
<style scoped>
.form-group {
  margin-bottom: 0px;
}

.link-white {
  color: #f2b636;
}

.link-white:hover {
  text-decoration: underline !important;
}
</style>
